import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IVacationCarryOverRequestState } from './vacation-carry-over-request.types';
import { IVacationCarryOverRequestData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IVacationCarryOverRequestState = {
  version: 1,
  count: 0,
  vacationCarryOverRequests: [] as IVacationCarryOverRequestData[],
  lastCreatedVacationCarryOverRequestCommentId: null,
  mentionableUsers: [],
  comments: [],
  activities: [],
  lastPromise: null
};

const namespaced = true;

export const vacationCarryOverRequest: Module<
  IVacationCarryOverRequestState,
  IRootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
